module.exports = __webpack_public_path__ + "static/img/hondurasMinistries.94e0891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/posters/hondurasMinistries.jpg
// module id = 6
// module chunks = 0